
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';
import { Capacitor } from '@capacitor/core';

export const createNotification = async (type, senderId, recipientId, wishlistId = null, senderName = '') => {
  const platform = Capacitor.getPlatform();
  console.log('🔔 [createNotification] CHIAMATA da piattaforma:', platform, 'con:', { type, senderId, recipientId, wishlistId, senderName });
  
  // Don't send notifications to self
  if (senderId === recipientId) {
    console.log('⚠️ [createNotification] Notifica non inviata: mittente e destinatario sono lo stesso utente');
    return;
  }

  try {
    const notificationData = {
      type,
      senderId,
      recipientId,
      wishlistId,
      senderName,
      isRead: false,
      createdAt: serverTimestamp(),
      retryCount: 0,
      maxRetries: 3
    };

    console.log('📝 [createNotification] Piattaforma:', platform, '- Tentativo scrittura in Firestore:', notificationData);
    
    const docRef = await addDoc(collection(db, 'notifications'), notificationData);
    console.log('✅ [createNotification] Notifica creata con successo da piattaforma:', platform, '! ID:', docRef.id, 'Tipo:', type, 'Destinatario:', recipientId);
    
    // Track notification creation for analytics
    try {
      await addDoc(collection(db, 'notification_metrics'), {
        type,
        created: true,
        timestamp: serverTimestamp(),
        recipientId: recipientId
      });
    } catch (metricsError) {
      console.warn('⚠️ Errore nel tracciamento metrica notifica:', metricsError);
    }
    
  } catch (error) {
    console.error('❌ [createNotification] Errore creazione notifica da piattaforma:', platform, error);
    console.error('❌ [createNotification] Stack trace:', error.stack);
    
    // Retry logic for notification creation
    setTimeout(async () => {
      try {
        console.log('🔄 [createNotification] Tentativo RETRY da piattaforma:', platform);
        await addDoc(collection(db, 'notifications'), {
          type,
          senderId,
          recipientId,
          wishlistId,
          senderName,
          isRead: false,
          createdAt: serverTimestamp(),
          retryCount: 1,
          isRetry: true
        });
        console.log('✅ [createNotification] Notifica creata al secondo tentativo da piattaforma:', platform, '- Tipo:', type);
      } catch (retryError) {
        console.error('❌ [createNotification] Errore anche al retry da piattaforma:', platform, retryError);
        console.error('❌ [createNotification] Retry stack trace:', retryError.stack);
        
        // Log failed notification creation
        try {
          await addDoc(collection(db, 'failed_notification_creations'), {
            type,
            senderId,
            recipientId,
            wishlistId,
            error: retryError.message,
            timestamp: serverTimestamp()
          });
        } catch (logError) {
          console.error('❌ Impossibile loggare errore di notifica:', logError);
        }
      }
    }, 2000); // Wait 2 seconds before retry
  }
};

// Funzione per inviare notifica di like
export const sendLikeNotification = async (senderId, senderName, recipientId, wishlistId) => {
  const platform = Capacitor.getPlatform();
  console.log('👍 [sendLikeNotification] CHIAMATA da piattaforma:', platform, 'con:', { senderId, senderName, recipientId, wishlistId });
  if (senderId !== recipientId) {
    await createNotification('like', senderId, recipientId, wishlistId, senderName);
  } else {
    console.log('⚠️ [sendLikeNotification] Skipped: sender === recipient');
  }
};

// Funzione per inviare notifica di follow
export const sendFollowNotification = async (senderId, senderName, recipientId) => {
  const platform = Capacitor.getPlatform();
  console.log('👥 [sendFollowNotification] CHIAMATA da piattaforma:', platform, 'con:', { senderId, senderName, recipientId });
  if (senderId !== recipientId) {
    await createNotification('follow', senderId, recipientId, null, senderName);
  } else {
    console.log('⚠️ [sendFollowNotification] Skipped: sender === recipient');
  }
};

// Funzione per inviare notifica di collaborazione
export const sendCollaborationNotification = async (senderId, senderName, recipientId, wishlistId) => {
  if (senderId !== recipientId) {
    await createNotification('collaboration', senderId, recipientId, wishlistId, senderName);
  }
};
